import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Card, Col, Container, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import styled from "styled-components";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { SuperAdminAction } from "../../Actions";
import * as CloudVpcActions from "../../Actions/CloudVpcActions/actions";
import t from "../../Actions/CloudVpcActions/type";
import CustomContentAlert, { navigationButtons } from "../helper";
import getPropertyId from "../../Utils/getPropertyId";
import Loader from "../Loader/Loader";
import AddCloudVpcModal from "./AddCloudVpcModal";
import CloudVpcDeleteModal from "./CloudVpcDeleteModal";

class CloudVPC extends Component {
  constructor(props) {
    super(props);
    this.addActionRef = createRef();
    this.state = {
      searchValue: "",
      prevPage: "",
      prevSearch: "",
      prevNorow: "",
      filterdCloudVPC: [],
      allCloudVPCList: [],
      newCloudVPCList: [],
      loader: false,
      api_response: false,
      showPropertyModal: false,
      isModalOpen: false,
      page: 1,
      Norow: 10,
      selectedColumn: "alias",
      asc: "false",
      sort_direction: "DESC",
      count: 0,
      findMore: false,

      loader: true,
      isModalOpen: false,
      deleteRowData: {},
    };

    // Columns defined inside constructor or as a class property
    this.columns = [
      { flex: 1, minWidth: 150, headerName: "MAC ID", field: "mac_id" },
      { flex: 1, minWidth: 130, headerName: "Public IP", field: "public_ip" },
      { flex: 0.8, minWidth: 100, headerName: "Server", field: "server" },
      { 
        flex: 0.5, 
        minWidth: 80, 
        headerName: "Active", 
        field: "active",
        renderCell: (params) => (params.value === 1 ? "Yes" : "No")
      },
      { 
        flex: 1, 
        minWidth: 150, 
        headerName: "Last Sync", 
        field: "last_sync",
        renderCell: (params) => {
          if (!params.value) return "-";
          const date = new Date(params.value);
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const year = date.getFullYear();
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
        }
      },
      {
        flex: 1,
        minWidth: 120,
        maxWidth: 150,
        headerName: "Action",
        field: "actions",
        renderCell: (rowData) => !this.props.modelOpenCLose && (
          <>
            <OverlayTrigger placement="bottom" overlay={(p)=><Tooltip {...p}>Edit</Tooltip>}>
              <ActionIcon onClick={() => this.editRow(rowData)}>
                <i className="fas fa-pen m-auto" />
              </ActionIcon>
            </OverlayTrigger>
            <OverlayTrigger placement="bottom" overlay={(p)=><Tooltip {...p}>Delete</Tooltip>}>
              <ActionIcon onClick={() => this.deleteRowTrigger(rowData)}>
                <div className="m-auto text-center">{this.deleIcon()}</div>
              </ActionIcon>
            </OverlayTrigger>
          </>
        ),
      },
    ];
  }

  componentDidMount() {
    this.setState({ loader: true }, async () => {
      const pid = getPropertyId(this.props);
      await this.props.actions.fetchCloudVpcDevices(pid, true);
      this.setState({
        allLotList: this.props.getAllLotsPaginated,
        count: this.props.count,
        api_response: this.props.api_response,
      });
      this.setState({ loader: false });
    });
  }

  componentDidUpdate(prevProps) {
    // Handle Loader state
    if (prevProps.vpcDevices !== this.props.vpcDevices) {
      this.setState({ loader: false });
    }

    // Handle Auto-hide Error Messages
    if (this.props.apiMessage?.message && prevProps.apiMessage?.message !== this.props.apiMessage?.message) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.props.dispatch({ type: t.SET_VPC_DEVICE_ERROR, payload: "" });
      }, 5000);
    }
  }

  componentWillUnmount() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  deleIcon = () => (
    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM3 6H11V16H3V6ZM10.5 1L9.5 0H4.5L3.5 1H0V3H14V1H10.5Z" fill="black" />
    </svg>
  );

  modelHandle = () => {
    this.props.dispatch({ type: t.SET_VPC_DEVICE_DATA, payload: [] });
    this.props.dispatch({ type: t.CLOSE_OPEN_MODEL, payload: true });
    this.props.dispatch({ type: t.SET_VPC_CREATE_FLAG, payload: true });
  };

  editRow = (rowData) => {
    this.props.dispatch({ type: t.SET_VPC_DEVICE_DATA, payload: rowData?.row });
    this.props.dispatch({ type: t.CLOSE_OPEN_MODEL, payload: true });
    this.props.dispatch({ type: t.SET_VPC_CREATE_FLAG, payload: false });
  };

  deleteRowTrigger = (rowData) => {
    this.setState({ isModalOpen: true, deleteRowData: rowData });
  };

  deleteVpcData = (rowData) => {
    const vpcId = rowData?.row?.id;
    const currentPropertyId = getPropertyId(this.props) || this.props.propertyId;
    this.props.actions.deleteCloudVpc({ id: vpcId, propertyId: currentPropertyId });
    this.setState({ isModalOpen: false });
  };

  render() {
    const { vpcDevices, modelOpenCLose, apiMessage, propertyId } = this.props;
    const currentPropertyId = getPropertyId(this.props) || propertyId;
    const { loader, isModalOpen, deleteRowData } = this.state;

    return (
      <>
        <Container fluid>
          <Row className="h-100">
            <Col md="12">
              <Card className="h-100">
                <Card.Header className="d-flex align-items-start justify-content-between">
                  <div>
                    <Card.Title as="h4">Manage Cloud VPC Devices</Card.Title>
                    <p className="card-category">View and configure cloud-based VPC network devices.</p>
                  </div>
                </Card.Header>
                <Card.Body>
                  {loader ? <Loader /> : (
                    <StyledDiv className="edgeDevicesTable">
                      {vpcDevices?.length === 0 ? (
                        <div className="text-center">No VPC records found</div>
                      ) : (
                        <DataGrid
                          rows={(vpcDevices || []).map((item) => ({
                            ...item,
                            id: item.id,
                          }))}
                          columns={this.columns}
                          slots={{ toolbar: GridToolbar }}
                          pageSizeOptions={[5, 10, 20]}
                          disableRowSelectionOnClick
                        />
                      )}
                    </StyledDiv>
                  )}
                  <Col lg="12" className="p-0">
                    {navigationButtons("/network-setup", "/add-vpc-device", currentPropertyId, this.addActionRef, "Add VPC Device", null, null, null, () => {
                      this.modelHandle();
                    })}
                  </Col>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        
        {isModalOpen && (
          <CloudVpcDeleteModal
            showBrowserModal={isModalOpen}
            closeModal={() => this.setState({ isModalOpen: false })}
            deleteVpcData={this.deleteVpcData}
            rowData={deleteRowData}
          />
        )}
        
        {modelOpenCLose && <AddCloudVpcModal show={modelOpenCLose} propertyId={currentPropertyId} />}
        
        {apiMessage?.isSuccess && apiMessage.message !== "" && (
          <CustomContentAlert delay={4000} message={apiMessage.message} className="toast-success" />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  modelOpenCLose: state.CloudVpcDetails.modelOpenClose,
  apiLoader: state.CloudVpcDetails.loader,
  vpcDevices: state.CloudVpcDetails.vpcDevices,
  apiMessage: state.CloudVpcDetails.message,
  setDomainHeader: SuperAdminAction.setDomainHeader,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  actions: bindActionCreators(CloudVpcActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CloudVPC);

const ActionIcon = styled.div`
  display: inline-block;
  width: 48px;
  height: 48px;
  padding: 13px 16px;
  cursor: pointer;
  &:hover { background-color: rgba(0, 0, 0, 0.04); border-radius: 50%; }
`;

const StyledDiv = styled.div`
  width: 100%;
  height: calc(100vh - 300px);
`;